var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNoPlayer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.1157 33.5169C28.093 36.0056 24.221 37.5 20 37.5C10.335 37.5 2.5 29.665 2.5 20C2.5 15.6237 4.10641 11.6225 6.76173 8.55411L31.1157 33.5169ZM32.9282 31.7947L8.52792 6.78445C11.5998 4.11557 15.6112 2.5 20 2.5C29.665 2.5 37.5 10.335 37.5 20C37.5 24.5441 35.768 28.6837 32.9282 31.7947ZM40 20C40 31.0457 31.0457 40 20 40C8.9543 40 0 31.0457 0 20C0 8.9543 8.9543 0 20 0C31.0457 0 40 8.9543 40 20Z",
    fill: "#CCCFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNoPlayer);
export default __webpack_public_path__ + "static/media/icon-no-player.9c2eafb3c2f63ba52f877bb4c6950941.svg";
export { ForwardRef as ReactComponent };